import React from 'react';
import Header from "../../components/Header/Header"
import HeroArea from "../../components/HeroArea/HeroArea"
import Courses from "../../components/Courses/Courses"
import About from "../../components/About/About"
import Gallary from "../../components/Gallary/Gallary"
import Contact from "../../components/Contact/Contact"
import Footer from '../../components/Footer/Footer';
const Home = () => {
    return (
        <>
            <Header />
            <HeroArea />
            <Courses />
            <About />
            <Gallary />
            <Contact />
            <Footer />
        </>
    );
};

export default Home;